import DeviceInfo from "react-native-device-info";

// This function is used to enumerate the available audio output options
// as well as the preferred audio output option. Preffered audio output
// option is the one that the user is currently using.
export function getAudioOptions(): {
  options: ("BLUETOOTH" | "WIRED_HEADSET" | "SPEAKER")[];
  preferred: "BLUETOOTH" | "WIRED_HEADSET" | "SPEAKER";
} {
  const isBluetoothHeadsetConnected =
    DeviceInfo.isBluetoothHeadphonesConnectedSync();
  const isWiredHeadsetConnected = DeviceInfo.isWiredHeadphonesConnectedSync();

  if (isBluetoothHeadsetConnected && isWiredHeadsetConnected) {
    return {
      options: ["BLUETOOTH", "WIRED_HEADSET", "SPEAKER"],
      preferred: "BLUETOOTH",
    };
  } else if (isBluetoothHeadsetConnected) {
    return { options: ["BLUETOOTH", "SPEAKER"], preferred: "BLUETOOTH" };
  } else if (isWiredHeadsetConnected) {
    return {
      options: ["WIRED_HEADSET", "SPEAKER"],
      preferred: "WIRED_HEADSET",
    };
  } else {
    return { options: ["SPEAKER"], preferred: "SPEAKER" };
  }
}
